import { useState } from 'react';
import { ClarityEvents } from '../../../../../../../lib/clarity/types/clarityEvents.types';
import { captureEventWithName } from '../../../../../../../lib/clarity/utils/captureEvent.utils';
import { useObjectContext } from '../../../hooks/useObjectContext';
import { ObjectLabel } from '../../../objectScreen.types';

const openStateMemory = new Map<string, boolean>();

interface UseDetailsSectionParams {
  title: ObjectLabel;
  isDefaultOpen: boolean;
  persistKey?: string;
}

export function useDetailsSection({ title, isDefaultOpen, persistKey }: UseDetailsSectionParams) {
  const { objectType } = useObjectContext();
  const memoryKey = persistKey ? `${objectType}:${persistKey}:${String(title)}` : undefined;

  const [isOpen, setIsOpen] = useState(() => {
    if (memoryKey && openStateMemory.has(memoryKey)) {
      return openStateMemory.get(memoryKey) ?? isDefaultOpen;
    }

    return isDefaultOpen;
  });

  const toggle = () => {
    if (!isOpen) {
      captureEventWithName(
        ClarityEvents.OBJECT_SCREEN_EXPANDED_DETAILS_SECTION_WITH_NAME,
        persistKey ?? String(title),
      );
    }

    setIsOpen((current) => {
      const next = !current;
      if (memoryKey) {
        openStateMemory.set(memoryKey, next);
      }

      return next;
    });
  };

  return { isOpen, toggle };
}
